module.exports = __webpack_public_path__ + "static/media/BobabarProcess1.6c8d996a.jpg";